import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import Title from '../../../containers/Editor/Title';
import ButtonBack from '../../../containers/Editor/ButtonBack';
import ButtonPreview from '../../../containers/Editor/ButtonPreview';
import ButtonPublish from '../../../containers/Editor/ButtonPublish';
import ButtonEdit from '../../../containers/Editor/ButtonEdit';
import ButtonZoom from '../ButtonZoom';
import ButtonSettings from '../../../containers/Editor/ButtonSettings';
import ButtonsUndoRedo from '../../../containers/Editor/ButtonsUndoRedo';
import { zoomPage } from '../../../containers/Editor/actions';
import { Wrapper, ButtonsGroup } from './styles';
import Utils from '../../../utils';

interface HeaderProps {
	isEditorLoaded: boolean;
	isButtonEditDisplayed: boolean;
	isButtonSettingsDisplayed: boolean;
	isButtonPublishDisplayed: boolean;
	shouldDisableButtons: boolean;
	dispatch: Dispatch<StoreState>;
	isAccessibleVersion: boolean;
}

const Header = ({
	isEditorLoaded,
	isButtonEditDisplayed,
	isButtonSettingsDisplayed,
	isButtonPublishDisplayed,
	shouldDisableButtons,
	dispatch,
	isAccessibleVersion,
}: HeaderProps) => (
	<Wrapper>
		{!Utils.isEmbedMode() && <ButtonBack />}
		{isEditorLoaded &&
			<>
				<Title />
				<ButtonZoom
					isDisabled={shouldDisableButtons}
					onClick={(zoom) => dispatch(zoomPage(zoom))}
				/>
				<ButtonsUndoRedo isBothDisabled={shouldDisableButtons} />
				<ButtonsGroup>
					{isButtonEditDisplayed && <ButtonEdit />}
					{isButtonSettingsDisplayed && <ButtonSettings isDisabled={shouldDisableButtons} />}
				</ButtonsGroup>
				<ButtonsGroup>
					<ButtonPreview isDisabled={shouldDisableButtons} />
					{isButtonPublishDisplayed && !isAccessibleVersion && <ButtonPublish isDisabled={shouldDisableButtons} />}
				</ButtonsGroup>
			</>
		}
	</Wrapper>
);

export default Header;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Header/index.tsx